import { cn } from '@/lib/ui/utils';

/** Phone 2×2 metrics; tablet one row of four under identity. Used by the table and Your rank card. */
export const MARKET_TRADERS_MOBILE_ROW_CLASS: string = cn(
  'max-xl:grid max-xl:items-start max-xl:gap-x-4 max-xl:gap-y-2',
  'max-sm:grid-cols-[1.75rem_minmax(0,1fr)_minmax(0,1fr)]',
  'sm:max-xl:grid-cols-[1.75rem_repeat(4,minmax(0,1fr))]',
  'max-xl:[&>:nth-child(1)]:self-center',
  'max-sm:[&>:nth-child(2)]:col-span-2 sm:max-xl:[&>:nth-child(2)]:col-span-4',
  'max-xl:[&>:nth-child(3)]:col-start-2',
  'max-sm:[&>:nth-child(3)]:mt-4 max-sm:[&>:nth-child(4)]:mt-4',
  'sm:max-xl:[&>:nth-child(n+3)]:mt-4',
  'max-sm:[&>:nth-child(5)]:col-start-2',
);
